import * as React from "react";
import TherapySubCats from "../navigation/TherapySubCats";

//Simply navigates to the Therapy Sub-Categories Stack Navigation
export default function TherapyScreen() {
  return (
    <TherapySubCats/>
  );
}
